module.exports = __webpack_public_path__ + "img/00047.cb7ab0e4.webp";